import { doc, getDoc } from "@firebase/firestore";
import { showErrorSnackbar, showWarningSnackbar } from "../../../../shared/snackbar/snackbar-slice";

export const getForSaleEssentialsDetailsDataService = async (dispatch, db, coll, id) => {
    try {
        const docRef = doc(db, coll, id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return docSnap.data();
        } else {
            dispatch(showWarningSnackbar("This document no longer exists."));
        }
    } catch(e) {
        dispatch(showErrorSnackbar('Fetch failed! Please try again.'))
        console.error("ForSaleEssentialsDetails getForSaleEssentialsDetailsDataService error: ", e);
    }
};